import axios from 'axios';
import * as config from "../config";

export const DASHBOARD_OFFERS_REQUEST = "DASHBOARD_OFFERS_REQUEST" 
export const DASHBOARD_OFFERS_ERROR = "DASHBOARD_OFFERS_ERROR" 
export const DASHBOARD_OFFERS_SUCCESS = "DASHBOARD_OFFERS_SUCCESS"

export function Get(id){
    return (dispatch) =>{
        dispatch({
            type:DASHBOARD_OFFERS_REQUEST
        });

        axios.get(
            config.apiUrl + "/dashboard/listofferdetails",
            {
                params:{
                    companyId:id
                }
            }
        )
        .then((response)=>{
            dispatch({
                type:DASHBOARD_OFFERS_SUCCESS,
                payload:response.data.content
            })
        }).catch((error)=>{
            dispatch({
                type:DASHBOARD_OFFERS_ERROR
            })
        })
    }
}




// WEBPACK FOOTER //
// ./src/actions/dashboardOffersActions.js